import Api from "../../services/Api.ts";
import {useEffect, useState} from "react";
import {useParams, useNavigate} from "react-router";
import Breadcrumbs, {Crumb} from "../../components/Breadcrumbs/Breadcrumbs.tsx";
import Checkbox from "../../components/Checkbox/Checkbox.tsx";
import CustomButton from "../../components/CustomButton/CustomButton.tsx";
import {ChevronDown} from "flowbite-react-icons/outline";

interface SurveyRequest {
  id: string
  created: string
  deadline: string
}

interface RespondentInterface {
  id: string
  name: string
  selected: boolean
}

interface DataInterface {
  requests: Array<SurveyRequest>
  surveyName: string
  categoryId: string
  categoryName: string
}

export default function Survey() {
  const api = Api.getInstance();
  const navigate = useNavigate();
  const { surveyId } = useParams();
  const [data, setData] = useState<DataInterface | null>(null);
  const [respondents, setRespondents] = useState<RespondentInterface[]>([]);
  const [deadline, setDeadline] = useState("");
  const [showCreate, setShowCreate] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get('customer/survey/' + surveyId + '/requests').then(response => {
      if (response.json.status === "ok") {
        setData(response.json.data);
        setRespondents(response.json.respondents)
        setLoaded(true)
      }
    })
  }, []);

  const createRequest = () => {

    const recipients = [];
    for (const respondent of respondents) {
      if (respondent.selected) {
        recipients.push({email: respondent.id, name: respondent.name});
      }
    }

    const requestDeadline = new Date(deadline);
    requestDeadline.setHours(23);

    const data = {
      deadline: requestDeadline,
      recipients: recipients
    }

    setLoaded(false);
    api.post('customer/survey/' + surveyId + '/create_request', data).then(response => {
      if (response.json.status === "ok") {
        setLoaded(true);
        navigate('/categories/request/' + response.json.requestId);
      }
    })
  }

  if (!loaded || !data) {
    return  <div className="main">Loading...</div>
  }

  const toggleRespondent = (respondentId: string) => {
    const _respondents = [...respondents]

    for (const respondent of _respondents) {
      if (respondent.id === respondentId) {
        respondent.selected = !respondent.selected
      }
    }
    setRespondents(_respondents)
  }

  const crumbs: Array<Crumb> = [
    {
      name: "Categories",
      link: "/categories"
    },
    {
      name: data.categoryName,
      link: "/categories/" + data.categoryId,
    },
    {
      name: "Survey: " + data.surveyName,
      link: "/categories/survey/" + surveyId,
    },
    {
      name: "Feedback requests"
    }
  ]

  return (
    <div className="main">
      <Breadcrumbs crumbs={crumbs}/>
      <div className="text-3xl font-medium mt-4">Feedback requests for {data.surveyName}</div>

      {
        data.requests.length > 0 ? (
          <table className="z-table z-spacing mt-2">
            <thead>
            <tr>
              <th>Created</th>
              <th>Deadline</th>
            </tr>
            </thead>
            <tbody>
            {
              data.requests.map((request, i) => (
                <tr key={"survey_" + i}>
                  <td className="cursor-pointer"
                      onClick={() =>
                        navigate('/categories/request/' + request.id)}>
                    {request.deadline.substring(0, 10)}
                  </td>
                  <td>{request.deadline.substring(0, 10)}</td>
                </tr>
              ))
            }
            </tbody>
          </table>
        ) : (
          <div className="mt-2">No feedback request yet</div>
        )
      }

      <hr className="z-hr mt-4"/>

      <div className="text-xl mt-8 cursor-pointer flex items-center" onClick={() => setShowCreate(!showCreate)}>
        <p>Create a customer feedback request</p>
        <ChevronDown className={"ml-2 h-6 w-6 " + (showCreate ? "rotate-180" : "")}/>
      </div>

      {
        showCreate &&
          <>
            <div className="mt-4">
                Deadline: <input type="date" className="z-input-date" value={deadline}
                                 onChange={(e) => setDeadline(e.target.value)}/>
            </div>

            <div className="mt-4">
                Select recipients
              {
                respondents.map((respondent, i) => (
                  <div className="mt-2" key={"r_" + respondent.id}>
                    <Checkbox id={respondent.id} label={respondent.name}
                              checked={respondent.selected} onChange={() => toggleRespondent(respondent.id)}/>
                  </div>
                ))
              }
            </div>

            <div className="mt-4">
                <CustomButton disabled={respondents.filter(r => r.selected).length === 0 || deadline.length < 9}
                              buttonType="blueBase" onClick={() => createRequest()}>
                    Create and send feedback request
                </CustomButton>
            </div>
          </>
      }


    </div>
  )
}